import React, { useMemo } from 'react';
import { Icon } from 'Components';
import ToggleGroup, {
	ToggleOption
} from 'LearningManager/components/ToggleGroup';
import { ReportView } from '../../TrainingReports.types';
import { VIEW_LABELS } from '../../TrainingReports.constants';

interface ViewToggleProps {
	value: ReportView;
	onChange: (value: ReportView) => void;
	className?: string;
}

const VIEW_ICONS: Record<ReportView, 'viewDashboardIcon' | 'viewTableIcon'> = {
	[ReportView.Dashboard]: 'viewDashboardIcon',
	[ReportView.Report]: 'viewTableIcon'
};

const ViewToggle: React.FC<ViewToggleProps> = ({
	value,
	onChange,
	className
}) => {
	const options = useMemo<ToggleOption<ReportView>[]>(
		() =>
			Object.values(ReportView).map((view) => ({
				key: view,
				label: VIEW_LABELS[view],
				icon: <Icon type={VIEW_ICONS[view]} role="img" />
			})),
		[]
	);

	return (
		<ToggleGroup<ReportView>
			className={className}
			options={options}
			value={value}
			onChange={onChange}
			borders="rounded"
		/>
	);
};

export default ViewToggle;
